// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1664":"675a5e6544158875","2305":"7374c24ba3cc18ae","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","8199":"f01407468f07465e","8232":"47da558de73c2085"}[chunkId] + ".css";
};